import React from "react";
import "./ContactDetail.css";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";

const contactDetails = [
  {
    phone: "+91 9588452635   (Kanchan Sir)",
    address: "Building No.3, Rashtrasant Tukdoji Maharaj Nagpur University, Maharajbag, Nagpur",
  },
  {
    phone: "+44 3333441532",
    address: "02, Universal Square, Devonshire Street, North Manchester, M12 6JH",
  },
  {
    phone: "+91 7028866973",
    address: "Tanushree Nayudu, Cermakova 584/26, Czech Republic - 62500",
  },
  {
    phone: "+91 9822454682      (Sumit Sir)",
    address: "Welcome Society,katol Road KT Nagar ,Nagpur,Maharashtra, India -440013",
  },
];

const ContactDetailsSection = () => {
  return (
    <div className="contact-section-container">
      {contactDetails.map((detail, index) => (
        <div className="contact-card" key={index}>
          <div className="contact-icon-text">
            <FaPhoneAlt className="contact-icon" />
            <h3 className="contact-number">{detail.phone}</h3>
          </div>
          <div className="contact-icon-text">
            <FaMapMarkerAlt className="contact-icon" />
            <p className="contact-address">{detail.address}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactDetailsSection;
